import React, { Component } from 'react';

import { Auth } from 'aws-amplify';
import jwt_decode from 'jwt-decode';
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

function SimpleDialog({ onClose, timeOut, open }) {
  const { t } = useTranslation();

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Modal isOpen={open} centered size='sm'>
      <ModalHeader >
        {t('sessionUser:title')}
      </ModalHeader>
      <ModalBody>
        {t('sessionUser:lbTitle')}
        <h2 className="text-primary text-center">{timeOut}</h2>
        {t('sessionUser:lbSeconds')}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => handleListItemClick('live')}>
          {t('sessionUser:btnLive')}
        </Button>
        <Button color="secondary" onClick={() => handleListItemClick('death')}>
          {t('sessionUser:btnDeath')}
        </Button>
      </ModalFooter>
    </Modal >
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  timeOut: PropTypes.number.isRequired,
};

class SessionConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: ['live', 'death'],
      open: false,
      count: 0,
      delay: 1000
    };
  }
  componentDidMount() {
    clearInterval(this.interval);
    Auth.currentSession()
      .then(data => {
        this.getToken(data);
        if (document.documentElement.className.indexOf("nav-open") !== -1) {
          document.documentElement.classList.toggle("nav-open");
        }
      })
      .catch((error) => {
        console.log(error);
        this.logoutSessionAD();
      });
    this.interval = setInterval(this.tick, this.state.delay);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.delay !== this.state.delay) {
      clearInterval(this.interval);
      this.interval = setInterval(this.tick, this.state.delay);
    }
    if (prevState.count > 0) {
      switch (prevState.count) {
        case 60:
          console.log('Refresh your token message')
          break;
        case 25:
          if (this.state.open === false) {
            this.setState({
              open: true
            });
          }
          break;
        case 1:
          this.logoutSessionAD();
          break;
        default:
          break;
      }
    }
  }

  getToken = (data) => {
    const token = data.idToken.jwtToken;
    if (jwt_decode(token).exp > Date.now() / 1000) {
      this.setState({
        count: parseInt(process.env.REACT_APP_SESSION_TIME_USER)
      });
    }
  }
  logoutSessionAD = () => {
    try {
      Auth.signOut();
      this.removeSession();
    } catch (error) {
      console.log(error);
      this.removeSession();
    }
  }
  removeSession = () => {
    window.sessionStorage.removeItem('username');
    window.sessionStorage.removeItem('name');
    window.sessionStorage.removeItem('user');
    window.sessionStorage.removeItem('menu');
    window.sessionStorage.removeItem('token');
    window.sessionStorage.removeItem('node');
    window.sessionStorage.removeItem('menuId');
    window.location.href = '/login';
  }
  tick = () => {
    this.setState({
      count: this.state.count - 1
    });
  }
  handleDelayChange = (e) => {
    this.setState({ delay: Number(e.target.value) });
  }
  handleClose = (value) => {
    switch (value) {
      case 'live':
        this.refreshCurrentSession();
        this.setState({
          open: false
        });
        clearInterval(this.interval);
        this.interval = setInterval(this.tick, this.state.delay);
        break;
      case 'death':
        this.logoutSessionAD();
        break;
      default:
        break;
    }
  }

  refreshCurrentSession = () => {
    Auth.currentSession()
      .then(data => {
        this.getToken(data);
      })
      .catch((error) => {
        console.log(error);
        this.logoutSessionAD();
      });
  }

  onRefreshCurrentSession() {
    this.refreshCurrentSession();
    clearInterval(this.interval);
    this.interval = setInterval(this.tick, this.state.delay);
  }

  render() {
    return (
      <div>
        <SimpleDialog timeOut={this.state.count} open={this.state.open} onClose={this.handleClose} />
      </div>
    )
  }
}
export default SessionConfig;
